async function request(path, options = {}) {
  const isFormData = options.body instanceof FormData;
  const timeout = options.timeout || 60000;

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);

  try {
    const res = await fetch(`/api${path}`, {
      credentials: 'include',
      headers: isFormData ? undefined : { 'Content-Type': 'application/json' },
      ...options,
      signal: controller.signal,
    });
    if (res.status === 204) return null;
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw Object.assign(new Error(data.erro || 'Erro'), { status: res.status, data });
    return data;
  } finally {
    clearTimeout(timeoutId);
  }
}

export const get = (path, timeout) => request(path, timeout ? { timeout } : {});
export const post = (path, body) => request(path, { method: 'POST', body: JSON.stringify(body) });
export const postForm = (path, formData) => request(path, { method: 'POST', body: formData });
export const put = (path, body) => request(path, { method: 'PUT', body: JSON.stringify(body) });
export const del = (path) => request(path, { method: 'DELETE' });
